<template>
  <v-switch
    v-if="material"
    v-bind="$attrs"
    :label="label"
    :class="classes"
    :color="color"
    :input-value="value"
    @change="onChange"
  ></v-switch>
  <v-switch
    v-else
    v-bind="$attrs"
    persistent-hint
    inset
    color="var(--lightgreen)"
    :class="classes"
    :hint="value ? 'on' : 'off'"
    :label="label"
    :input-value="value"
    @change="onChange"
  >
    <!--@slot Slot padrão do componente -->
    <slot></slot>
  </v-switch>
</template>

<script>
/**
 * @displayName Switch
 */
export default {
  name: 'ZSwitch',
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    /**
     * Valor do modelo
     *
     * @modelName value
     */
    value: {
      type: Boolean,
      required: false,
      default: false,
    },
    /**
     * Label para o switch
     */
    label: {
      type: String,
      required: false,
      default: '',
    },
    /**
     * Cor para quando se usa o próprio do material
     */
    color: {
      type: String,
      required: false,
      default: 'primary',
    },
    /**
     * Estilo do switch
     */
    material: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    classes() {
      return {
        'zoox-component': true,
        'zoox-switch': true,
        default: !this.material,
        'is-on': this.value,
        'is-off': !this.value,
      }
    },
  },
  methods: {
    onChange() {
      /**
       * Evento disparado quando o valor do switch for alterado
       *
       * @property {Boolean} value - Valor atual do switch
       */
      this.$emit('change', !this.value)
    },
  },
}
</script>

<style lang="scss">
@mixin state-message {
  text-transform: uppercase;
  position: absolute;
  color: var(--white) !important;
  font-size: 0.625rem;
}

.zoox-switch {
  position: relative;

  &.default {
    .v-input--switch__track {
      opacity: 1 !important;
    }

    .v-input--switch__thumb {
      color: var(--white) !important;
      caret-color: var(--white) !important;
    }
  }

  &.default.is-off {
    .v-input--switch__track {
      color: var(--red) !important;
    }

    .v-messages__message {
      @include state-message;
      bottom: 28px;
      left: 22px;
    }
  }

  &.default.is-on {
    .v-messages__message {
      @include state-message;
      bottom: 28px;
    }
  }
}
</style>
